import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import PersonSelector from '@/components/PersonSelector.vue'
import ProblemSelector from '@/components/ProblemSelector.vue'
import Login from '@/components/Login.vue'
import FormsOverview from '@/components/FormsOverview.vue'
import FormView from '@/components/FormView.vue'
import jwtDecode from 'jwt-decode'
import { DateTime } from 'luxon'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
  	path: '/person',
  	name: 'PersonSelector',
  	component: PersonSelector
  },
   {
  	path: '/person/problem',
  	name: 'ProblemSelector',
  	component: ProblemSelector,
  	props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/my-forms',
    name: 'FormsOverview',
    component: FormsOverview
  },
  {
    path: '/form/:id',
    name: 'FormView',
    component: FormView,
    props: true
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to) {
    if (to.hash)
      return { selector: to.hash, offset: { y: 200 }}
}
})

router.beforeEach((to, from, next) => {
  const token = router.app.$session.get('token')
  if (to.name !== 'Login' && !token)
    next({name: 'Login'})
  else
    next()
})

export default router
